import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';


export default el => {
    const dom = $(el);
    const body = $('body');
    const header = dom.find('[data-header]');
    const scrollers = dom.find('[data-scroller]');
    const CUTOFF = 1200;
    const OFFSET_TOP = 50;
    const DEFAULT_DELAY = 0.2;

    const windowHeight = () => (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0);

    const windowScroll = () => (window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop || 0);

    const documentHeight = () => Math.max(
        document.body.scrollHeight || 0,
        document.documentElement.scrollHeight || 0,
        document.body.offsetHeight || 0,
        document.documentElement.offsetHeight || 0,
        document.body.clientHeight || 0,
        document.documentElement.clientHeight || 0
    );

    let headerWidth = 0;
    let scrollWidth = 0;
    let scrollPercent = 0;
    let controllerVisible = 0;
    let lastScroll = 0;
    let scrollDirection = 'down';

    const scroll = () => {
        const scrollTop = windowScroll();
        scrollPercent = scrollTop / (documentHeight() - windowHeight());
        scrollDirection = scrollTop > lastScroll ? 'down' : 'up';
        lastScroll = scrollTop;

        if (Viewport.width >= CUTOFF) {
            const scrollLeft = Math.round(scrollWidth * scrollPercent);
            TweenLite.to(el, 0.1, { scrollTo: { x: scrollLeft }, ease: Linear.easeNone });
            if (!controllerVisible && scrollLeft > headerWidth) {
                controllerVisible = true;
                Dispatch.emit(Events.CONTROLLER_SHOW);
            } else if (controllerVisible && scrollLeft < headerWidth) {
                controllerVisible = false;
                Dispatch.emit(Events.CONTROLLER_HIDE);
            }
        } else {
            if (el.scrollLeft !== 0) {
                el.scrollLeft = 0;
            }
            if (!controllerVisible && scrollTop >= OFFSET_TOP) {
                controllerVisible = true;
                Dispatch.emit(Events.CONTROLLER_SHOW);
            } else if (controllerVisible && scrollTop < OFFSET_TOP) {
                controllerVisible = false;
                Dispatch.emit(Events.CONTROLLER_HIDE);
            }
        }
    };

    const resize = () => {
        headerWidth = header.width();
        if (Viewport.width >= CUTOFF) {
            scrollWidth = el.scrollWidth - Viewport.width;
            body.css('height', `${Math.round(scrollWidth * (Viewport.height / Viewport.width))}px`);
        } else {
            body.attr('style', null);
        }
        scroll();
    };

    const setupBgTransitions = () => {
        const intersectionCallback = entries => {
            const intersecting = entries.filter(entry => entry.isIntersecting).map(entry => entry.target)[0] || false;

            if (intersecting) {
                const color = intersecting.getAttribute('data-color');
                const backgroundColor = intersecting.getAttribute('data-bg');
                TweenLite.to(document.body, 1, { backgroundColor, color, ease: Quad.easeOut });
            }
        };

        const observer = new IntersectionObserver(intersectionCallback, {
            rootMargin: '0px -25% 0px -25%',
            threshold: 0,
            root: null
        });

        dom.find('[data-bg]').each(node => {
            observer.observe(node);
            node.removeAttribute('style');
        });
    };

    const setupScrollReveal = () => {
        const intersectionCallback = (entries, obs) => {
            let delay = 0;
            entries.filter(entry => entry.isIntersecting).map(entry => entry.target).forEach(node => {
                const addedDelayMs = parseFloat(node.getAttribute('data-dual-reveal'));
                delay += isNaN(addedDelayMs) ? 0 : addedDelayMs;
                TweenLite.to(node, 2.25, { delay, x: 0, y: 0, ease: Expo.easeOut });
                TweenLite.to(node, 0.75, { delay, opacity: 1, ease: Cubic.easeInOut });
                obs.unobserve(node);
                delay += DEFAULT_DELAY;
            });
        };

        const observer = new IntersectionObserver(intersectionCallback, {
            rootMargin: '0px -5% 0px -5%',
            threshold: 0
        });

        $('[data-dual-reveal]').each(node => {
            observer.observe(node);
        });
    };

    const scrollToTarget = e => {
        e.preventDefault();
        const target = $(e.triggerTarget.getAttribute('href'));
        const offset = Math.ceil(Viewport.width < CUTOFF ? target.position().top : (target.position().left / scrollWidth) * (documentHeight() - windowHeight()));
        const duration = Viewport.width < CUTOFF ? 1.5 : 1.25;
        TweenLite.to(window, duration, { scrollTo: { y: offset, autoKill: false }, ease: Cubic.easeInOut });
    };

    const init = () => {
        Viewport.on('scroll', scroll);
        Viewport.on('resize', resize);
        resize();
        dom.css('overflow', 'hidden');
        requestAnimationFrame(() => {
            setupBgTransitions();
            setupScrollReveal();
        });
        scrollers.on('click', scrollToTarget);
    };

    const destroy = () => {
        Viewport.off('scroll', scroll);
        Viewport.off('resize', resize);
        scrollers.off('click', scrollToTarget);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Featured.js